var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgCustomersOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.65,
  d: "M11.373 10.347a2 2 0 0 1 3.12 1.814c-.799.28-1.649.388-2.493.319A3.996 3.996 0 0 0 8 8.5a3.997 3.997 0 0 0-3.372 1.848m7.371 2.131v.021c0 .15-.007.298-.024.444A7.962 7.962 0 0 1 8 14a7.962 7.962 0 0 1-3.975-1.056A4.041 4.041 0 0 1 4 12.479m0 0a5.987 5.987 0 0 1-2.493-.318 2 2 0 0 1 3.12-1.813M4 12.479a3.982 3.982 0 0 1 .628-2.131M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-9 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
})));
const Memo = /*#__PURE__*/memo(SvgCustomersOutlined);
export default Memo;